import { render, staticRenderFns } from "./CardBig.vue?vue&type=template&id=ca6d8078&"
import script from "./CardBig.vue?vue&type=script&lang=js&"
export * from "./CardBig.vue?vue&type=script&lang=js&"
import style0 from "./CardBig.vue?vue&type=style&index=0&id=ca6d8078&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports